import React from 'react'
import ReactDOM from 'react-dom'
import ReactPixel from 'react-facebook-pixel'

import App from './App'

import * as serviceWorker from './serviceWorker'

import 'normalize.css'
import './index.css'

ReactPixel.init('726490601707397', undefined, {
  debug: false,
  autoConfig: false
})

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('d405-app')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister()
